const HeroSection2 = () => {
  return (
    <div className="relative">
      <div className="container flex items-center mx-auto relative md:mt-60">
        <div className="flex flex-col justify-start items-end gap-2.5 px-4 lg:gap-6 pb-16 sm:pb-20 md:pb-32 lg:w-4xl pt-5 w-md sm:w-full">
          <div className="w-full flex flex-col gap-10">
            <p className="font-kalameh text-4xl hidden md:block">
              به مینی دوره ۳ روزه صداسازی خوش اومدی و دمت گرم که برای رشد صدات
              قدم برمیداری!
            </p>
            <div>
              <p className="font-kalameh text-[16px] md:text-2xl font-light md:max-w-md lg:max-w-xl">
                تو این مینی دوره در قالب ۳ فصل، نقشه راه رشد سریع صدات رو بهت
                نشون دادم
              </p>
              <p className="font-kalameh text-[16px] md:text-2xl font-light sm:max-w-sm md:max-w-md lg:max-w-xl">
                وقتی به آخر ویدیوی سوم برسی تو آماده ای برای برداشتن یک قدم جدی
                برای رشد صدات و حرفه ای تر خوندنت
              </p>
            </div>
            <div>
              <p className="font-kalameh text-[16px] font-light max-w-3xs pl-12 block md:hidden">
                راستی دقت کن فقط ۳ روز برای دیدن مینی دوره فرصت داری و هر روز یک
                فصل برات باز میشه پایان این مینی دوره یه سورپرایز جذاب در
                انتظارته!
              </p>
              <p className="hidden md:block font-kalameh text-[16px] md:text-2xl font-light max-w-[280px] md:max-w-md lg:max-w-xl">
                راستی دقت کن فقط ۳ روز برای دیدن مینی دوره فرصت داری و هر روز یک
                فصل برات باز میشه
              </p>
              <p className="hidden md:block font-kalameh text-[16px] md:text-2xl font-light md:max-w-md lg:max-w-xl">
                پایان این مینی دوره یه سورپرایز جذاب در انتظارته!
              </p>
            </div>
            <p className="font-kalameh text-[16px] md:text-2xl font-semibold w-36 md:w-full">
              برای آشنایی بیشتر ویدیو زیر رو ببین...
            </p>
          </div>
        </div>

        <img
          src="/images/hero.png"
          alt="hero"
          width={677}
          height={637}
          className="
    w-[298px] h-[281px]
    sm:w-[420px] sm:h-[395px]
    lg:w-[560px] lg:h-[525px]
    xl:w-[677px] xl:h-[637px]
    absolute -bottom-2 sm:-bottom-12 -z-10 left-0 xl:left-0
  "
        />
      </div>
      <div className="flex items-center justify-center">
        <img
          src="/images/visualaizer.png"
          alt="hero"
          width={297}
          height={53}
          className="w-[297px] h-[53px] lg:w-[595px] lg:h-[106px] absolute -bottom-6.5 lg:-bottom-13 z-10"
        />
      </div>
    </div>
  );
};

export default HeroSection2;
